export interface VesselSection {
  current: number;
  max: number;
  hasDealtHoleDamage?: boolean;
}

export interface VesselData {
  name: string;
  hullSections: number;
  sinkSections: number;
  decks: number;
  sectionsPerDeck: number;
  sectionHP: number;
  riggingSections: number;
  riggingHP: number;
  /** Stormwrack "Complement": everyone the ship can carry. Seeds crew size. */
  complement: number;
  /** Stormwrack "Watch": crew needed to sail her for one watch. */
  watch: number;
  /** Additional rowers a watch requires, for oared vessels. */
  rowers?: number;
}

export const VESSEL_DATA: Record<string, VesselData> = {
  'Barge': {
    name: 'Barge',
    hullSections: 80,
    sinkSections: 20,
    decks: 1,
    sectionsPerDeck: 80,
    sectionHP: 50,
    riggingSections: 0,
    riggingHP: 0,
    complement: 120,
    watch: 5,
    rowers: 40
  },
  'Caravel': {
    name: 'Caravel',
    hullSections: 24,
    sinkSections: 6,
    decks: 2,
    sectionsPerDeck: 12,
    sectionHP: 80,
    riggingSections: 3,
    riggingHP: 80,
    complement: 30,
    watch: 7
  },
  'Cog': {
    name: 'Cog',
    hullSections: 16,
    sinkSections: 4,
    decks: 2,
    sectionsPerDeck: 8,
    sectionHP: 80,
    riggingSections: 1,
    riggingHP: 60,
    complement: 20,
    watch: 4
  },
  'Coracle': {
    name: 'Coracle',
    hullSections: 1,
    sinkSections: 1,
    decks: 1,
    sectionsPerDeck: 1,
    sectionHP: 10,
    riggingSections: 0,
    riggingHP: 0,
    complement: 2,
    watch: 1
  },
  'Dhow': {
    name: 'Dhow',
    hullSections: 18,
    sinkSections: 4,
    decks: 3,
    sectionsPerDeck: 6,
    sectionHP: 50,
    riggingSections: 1,
    riggingHP: 60,
    complement: 25,
    watch: 5
  },
  'Dromond': {
    name: 'Dromond',
    hullSections: 60,
    sinkSections: 15,
    decks: 5,
    sectionsPerDeck: 12,
    sectionHP: 80,
    riggingSections: 2,
    riggingHP: 80,
    complement: 200,
    watch: 7,
    rowers: 100
  },
  'Dugout': {
    name: 'Dugout',
    hullSections: 1,
    sinkSections: 1,
    decks: 1,
    sectionsPerDeck: 1,
    sectionHP: 10,
    riggingSections: 0,
    riggingHP: 0,
    complement: 4,
    watch: 1
  },
  'Elf Wingship': {
    name: 'Elf Wingship',
    hullSections: 12,
    sinkSections: 3,
    decks: 1,
    sectionsPerDeck: 12,
    sectionHP: 150,
    riggingSections: 2,
    riggingHP: 80,
    complement: 30,
    watch: 5
  },
  'Galley': {
    name: 'Galley',
    hullSections: 78,
    sinkSections: 19,
    decks: 3,
    sectionsPerDeck: 26,
    sectionHP: 80,
    riggingSections: 2,
    riggingHP: 60,
    complement: 300,
    watch: 10,
    rowers: 160
  },
  'Greatship': {
    name: 'Greatship',
    hullSections: 240,
    sinkSections: 60,
    decks: 6,
    sectionsPerDeck: 40,
    sectionHP: 80,
    riggingSections: 4,
    riggingHP: 80,
    complement: 500,
    watch: 20
  },
  'Ironclad': {
    name: 'Ironclad',
    hullSections: 72,
    sinkSections: 18,
    decks: 3,
    sectionsPerDeck: 24,
    sectionHP: 150,
    riggingSections: 1,
    riggingHP: 60,
    complement: 120,
    watch: 5,
    rowers: 60
  },
  'Junk': {
    name: 'Junk',
    hullSections: 32,
    sinkSections: 8,
    decks: 2,
    sectionsPerDeck: 16,
    sectionHP: 50,
    riggingSections: 2,
    riggingHP: 80,
    complement: 50,
    watch: 7
  },
  'Keelboat': {
    name: 'Keelboat',
    hullSections: 3,
    sinkSections: 1,
    decks: 1,
    sectionsPerDeck: 3,
    sectionHP: 50,
    riggingSections: 1,
    riggingHP: 60,
    complement: 16,
    watch: 2,
    rowers: 8
  },
  'Launch': {
    name: 'Launch',
    hullSections: 1,
    sinkSections: 1,
    decks: 1,
    sectionsPerDeck: 1,
    sectionHP: 50,
    riggingSections: 0,
    riggingHP: 0,
    complement: 8,
    watch: 1,
    rowers: 2
  },
  'Longship': {
    name: 'Longship',
    hullSections: 14,
    sinkSections: 3,
    decks: 1,
    sectionsPerDeck: 14,
    sectionHP: 50,
    riggingSections: 1,
    riggingHP: 60,
    complement: 60,
    watch: 3,
    rowers: 40
  },
  'Pinnace': {
    name: 'Pinnace',
    hullSections: 4,
    sinkSections: 1,
    decks: 1,
    sectionsPerDeck: 4,
    sectionHP: 50,
    riggingSections: 2,
    riggingHP: 60,
    complement: 15,
    watch: 3,
    rowers: 8
  },
  'Raft': {
    name: 'Raft',
    hullSections: 1,
    sinkSections: 1,
    decks: 1,
    sectionsPerDeck: 1,
    sectionHP: 30,
    riggingSections: 0,
    riggingHP: 0,
    complement: 8,
    watch: 1,
    rowers: 2
  },
  'Rowboat': {
    name: 'Rowboat',
    hullSections: 1,
    sinkSections: 1,
    decks: 1,
    sectionsPerDeck: 1,
    sectionHP: 30,
    riggingSections: 0,
    riggingHP: 0,
    complement: 4,
    watch: 1
  },
  'Theurgeme': {
    name: 'Theurgeme',
    hullSections: 28,
    sinkSections: 7,
    decks: 2,
    sectionsPerDeck: 14,
    sectionHP: 150,
    riggingSections: 0,
    riggingHP: 0,
    complement: 40,
    watch: 1
  },
  'Trireme': {
    name: 'Trireme',
    hullSections: 32,
    sinkSections: 8,
    decks: 2,
    sectionsPerDeck: 16,
    sectionHP: 50,
    riggingSections: 1,
    riggingHP: 60,
    complement: 100,
    watch: 3,
    rowers: 70
  },
  'War Canoe': {
    name: 'War Canoe',
    hullSections: 2,
    sinkSections: 1,
    decks: 1,
    sectionsPerDeck: 2,
    sectionHP: 30,
    riggingSections: 1,
    riggingHP: 40,
    complement: 16,
    watch: 1,
    rowers: 12
  }
};
